import {
  ReportSection,
  ReportSectionConfigurationBase,
  ReportType,
  ReportViewModelSection
} from '@capital-access/reporting/common';
import { CommentaryModel } from './combined-ownership.model';

export class CommentaryConfiguration extends ReportSectionConfigurationBase {
  typeName = 'CommentaryConfiguration';
  readonly reportSection = ReportSection.None;
  nodataLocalizationKeyName = 'commentary';
  readonly name = 'enableCommentary';
  readonly displayName = 'Comments';
  readonly reportViewModelSections = [ReportViewModelSection.Commentary];
  readonly minSize = 1;
  readonly maxSize = 4;
  readonly defaultSize = 4;
  readonly applicableReportTypes = [ReportType.Contact, ReportType.Institution, ReportType.OwnershipAnalyticsReport];
  override get requirePostDataInput(): boolean {
    return true;
  }
  readonly availableDataSections = [];
}

export interface CommentaryData {
  [ReportViewModelSection.Commentary]: CommentaryModel;
}
